export default {
      id: "ic_photo-icon-usage",
      viewBox: "0 0 72 72",
      url: "/" + "images/icons.3.109.2.svg#ic_photo-icon-usage",
      toString: function () {
        return this.url;
      }
    }